<template>
  <div class="pagination">
    <template v-if="filteredResourcesCount > 0 && pagesCount > 1">
      <button href="#" v-show="value != 0" class="nav-btn first" @click="pageChange(0)"> {{ first }} </button>
      <button href="#" v-show="value != 0" class="nav-btn previous" @click="pageChange(value - 1)"> {{ previous }} </button>

      <div class="items">
      <template v-for="(page, num) in pages">
        <button href="#" :key="num" @click="pageChange(page.page_num)" :class="{'active': value == page.page_num}" class="item">{{ page.page }}</button>
      </template>
      </div>
      
      <button href="#" v-show="value != pagesCount - 1" class="nav-btn next" @click="pageChange(value + 1)"> {{ next }} </button>
      <button href="#" v-show="value != pagesCount - 1" class="nav-btn last" @click="pageChange(pagesCount - 1)"> {{ last }} </button>
    </template>
  </div>
</template>

<script>
import content from '@/translations/content'

export default {
  name: 'Pagination',
  mixins: [ content ],
  props: {
    filteredResourcesCount: Number,
    countPerPage: Number,
    value: Number,
  },
  computed: {
    pagesCount() {
      return Math.ceil(this.filteredResourcesCount / this.countPerPage)
    },
    pages() {
      if (this.pagesCount < 5) {
        return [...Array(this.pagesCount).keys()].map(num => ({
          page: num + 1,
          page_num: num
        }))
      } 

      let center_page = Math.max(3, Math.min(this.value + 1, this.pagesCount - 2))
      return [...Array(5).keys()].map(num => ({
        page: num + center_page - 2, 
        page_num: num + center_page - 3
      }))
    },
  },
  methods: {
    pageChange(page) {
      this.$emit('input', page)
    }
  }
}
</script>